import {CanActivate, Routes} from '@angular/router';
import {TasksComponent} from './tasks/tasks/tasks.component';
import {ContactsComponent} from './contacts/contacts.component';
import {UsersComponent} from './users/users.component';
import {LoginComponent} from './login/login.component';
import {CalendarComponent} from './calendar/calendar.component';
import {CustomerServiceComponent} from './customer-service/customer-service.component';
import {MapComponent} from './map/map.component';
import {NotificationsComponent} from './notifications/notifications.component';
import {AuthGuard} from '@angular/fire/auth-guard';
import {LegislativeActionComponent} from './legislative-action/legislative-action.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {AdminComponent} from './admin/admin.component';
import {SubscriptionComponent} from './subscription/subscription.component';
import {inject, Injectable} from '@angular/core';
import {AuthService} from './services/auth.service';
import {subscriptionGuard} from './guards/subscription.guard';

@Injectable({
  providedIn: 'root'
})
class AuthAdminGuard implements CanActivate {
  authService = inject(AuthService);
  canActivate() {
    return this.authService.loggedUser()?.superAdmin ?? false;
  }
}

export const routes: Routes = [
  { path: 'tarefas', component: TasksComponent, canActivate: [AuthGuard, subscriptionGuard]},
  { path: 'tarefas/:taskId', component: TasksComponent, canActivate: [AuthGuard, subscriptionGuard]},
  { path: 'contatos', component: ContactsComponent, canActivate: [AuthGuard, subscriptionGuard] },
  { path: 'contatos/:contactId', component: ContactsComponent, canActivate: [AuthGuard, subscriptionGuard] },
  { path: 'usuarios', component: UsersComponent, canActivate: [AuthGuard, subscriptionGuard] },
  { path: 'relatorios', component: DashboardComponent, canActivate: [AuthGuard, subscriptionGuard] },
  { path: 'calendario', component: CalendarComponent, canActivate: [AuthGuard, subscriptionGuard] },
  { path: 'calendario/:eventId', component: CalendarComponent, canActivate: [AuthGuard, subscriptionGuard] },
  { path: 'atendimentos', component: CustomerServiceComponent, canActivate: [AuthGuard, subscriptionGuard] },
  { path: 'atendimentos/:csId', component: CustomerServiceComponent, canActivate: [AuthGuard, subscriptionGuard] },
  { path: 'acoes-legislativas', component: LegislativeActionComponent, canActivate: [AuthGuard, subscriptionGuard] },
  { path: 'acoes-legislativas/:laId', component: LegislativeActionComponent, canActivate: [AuthGuard, subscriptionGuard] },
  { path: 'mapa', component: MapComponent, canActivate: [AuthGuard, subscriptionGuard] },
  { path: 'notificacoes', component: NotificationsComponent, canActivate: [AuthGuard, subscriptionGuard] },
  { path: 'admin', component: AdminComponent, canActivate: [AuthGuard, AuthAdminGuard] },
  { path: 'assinatura', component: SubscriptionComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: 'calendario', pathMatch: 'full' },
];
